import { render, staticRenderFns } from "./SetupDrawer.vue?vue&type=template&id=57aec77f"
import script from "./SetupDrawer.vue?vue&type=script&lang=js"
export * from "./SetupDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports